import { cancelExportImportJob } from '@/features/AudienceManager/services';
export const postCancelExportImportJob = (batchId) => {
    return cancelExportImportJob(batchId).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        batchId: response.data[0].batchId,
        errors: response.errors,
        success: response?.success,
    };
};
